export default "__VITE_ASSET___n_dmgQH__"